/**
     * @desc 获取加油站信息列表数据
where查询条件
     */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.ResPetrolStationPageParams>): Promise<BaseResponse<defs.PageBean<Array<defs.ResPetrolStation>>>> {
  return fetch({
    url: config.API_HOST + '/base/resPetrolStation/pageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
